import { useQuery } from "@tanstack/react-query";
import { IGetRouteListParams, RouteService } from "../../../../../services/vos/business-tickets/route.service";

const useRoute = (params?: IGetRouteListParams & { enabled?: boolean }) => {
  const query = useQuery({
    queryKey: ["route", params?.keySearch],
    queryFn: () => RouteService.getRouteList(params),
    keepPreviousData: true,
    enabled: params?.enabled !== undefined ? params.enabled : !!params?.keySearch,
  });

  return query;
};

export default useRoute;
